import CarouselContainer from 'components/CreateAcademy/CarouselContainer/CarouselContainer';
import HowWorks from 'components/CreateAcademy/HowWorks/HowWorks';
import Examples from 'components/CreateAcademy/Examples/Examples';
import Advantages from 'components/CreateAcademy/Advantages/Advantages';
import Start from 'components/CreateAcademy/Start/Start';
import AcademyPrices from 'components/CreateAcademy/AcademyPrices/AcademyPrices';
import EduStorePrices from 'components/CreateAcademy/EduStorePrices/EduStorePrices';

const CreateAcademy = () => {
  return (
    <>
      <CarouselContainer />
      <HowWorks />
      <Examples />
      <Advantages />
      <Start />
      <AcademyPrices />
      <EduStorePrices />
    </>
  );
};

export default CreateAcademy;
